import { useCallback, useState } from 'react';

import type { LineageFilterState, LineageHierarchyType } from '@/shared/types/lineage';

export const useLineageFilter = () => {
  const [filterState, setFilterState] = useState<LineageFilterState>({
    depth: 5,
    direction: 'both',
    entityTypes: [],
    viewOptions: {
      selectedHierarchies: new Set<LineageHierarchyType>(),
    },
  });

  const handleHierarchiesChange = useCallback((hierarchies: Set<LineageHierarchyType>) => {
    setFilterState((prev) => ({
      ...prev,
      viewOptions: {
        selectedHierarchies: hierarchies,
      },
    }));
  }, []);

  return {
    filterState,
    handleHierarchiesChange,
  };
};
